import Image from "@/components/Image";
import { AnimatePresence, motion } from "framer-motion";
import { useCallback } from "react";
import { exandMore } from "./data";
import type { MenuType } from "./type";

const HEIGHT_ITEM = 56;
const SPACE_ITEM = 12;
const BASE_X = 0;
const BASE_Y = 0;

const MOTION_VALUE = {
  hidden: () => ({
    opacity: 0,
    right: BASE_X,
    bottom: 0,
    rotate: 0,
    x: 56 / 2,
    y: 56 / 2,
  }),
  visible: (index: number) => ({
    x: 56 / 2,
    y: 0,
    opacity: 1,
    right: -(index * (8 + index * 1.3)),
    bottom: (index + 1) * (HEIGHT_ITEM + SPACE_ITEM) + BASE_Y,
    rotate: (index + 1) * 2 + 3,
    ease: ["easeIn", "easeOut"],
  }),
};

export const MoreFolder = (props: {
  menuActive?: MenuType;
  onSelect: (item?: MenuType) => void;
}) => {
  const { onSelect, menuActive } = props;

  const handleOpenApp = useCallback(
    (item: MenuType) => {
      onSelect(item);
    },
    [onSelect]
  );

  return (
    <div className="relative flex items-center justify-end">
      <AnimatePresence initial={false}>
        {exandMore.map((item, index) => {
          return (
            <motion.div
              key={`${item.key}-${index}`}
              custom={index}
              data-action={item.dataAction}
              initial={menuActive?.key === "folder" ? "visible" : "hidden"}
              animate={menuActive?.key === "folder" ? "visible" : "hidden"}
              className="absolute flex gap-x-4 items-center justify-end hover:cursor-pointer w-[160px]"
              variants={MOTION_VALUE}
              onClick={() => {
                handleOpenApp(item);
              }}
            >
              <motion.span
                initial={{
                  scale: menuActive?.key === "folder" ? 1 : 0,
                }}
                animate={{ scale: menuActive?.key === "folder" ? 1 : 0 }}
                className="inline-block overflow-hidden text-sm text-right font-medium text-white bg-black px-2 py-[2px] border-1 border-[#23262F] rounded-lg"
              >
                {item.label}
              </motion.span>
              <Image
                src={item.img}
                alt={item.label}
                className="w-[56px] h-[56px] rounded-xl"
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
